import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@olxbr/design-system'

const PurplePlaneIcon = props => (
  <View>
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M48.1149 87.3109C69.762 87.3109 87.3104 69.7625 87.3104 48.1154C87.3104 26.4683 69.762 8.91992 48.1149 8.91992C26.4679 8.91992 8.91943 26.4683 8.91943 48.1154C8.91943 69.7625 26.4679 87.3109 48.1149 87.3109Z"
        fill="#6E0AD6"
      />
      <path
        d="M18.7273 47.9471C16.3415 49.1988 16.4405 51.032 18.9418 52.0218L26.3529 54.9541C28.8562 55.948 32.6442 55.4056 34.7661 53.7498L66.9488 28.3699C69.0645 26.7058 69.2913 26.9512 67.454 28.9184L42.0122 56.15C40.1687 58.1111 40.7131 60.5196 43.2247 61.4908L44.0928 61.829C46.6044 62.8002 50.6976 64.4313 53.1927 65.4459L61.4122 68.7926C63.9093 69.8071 66.5776 68.6111 67.287 66.0129L79.8141 19.9669C80.5213 17.3687 79.148 16.2655 76.7622 17.5151L18.7273 47.9471Z"
        fill="white"
        stroke="#4A4A4A"
        strokeWidth="1.5"
      />
      <path
        d="M39.0655 78.0928C38.9191 78.532 44.134 70.5415 44.134 70.5415C45.6084 68.2897 44.7712 65.6028 42.2802 64.5842L36.593 62.2561C34.1021 61.2374 32.9081 62.4334 33.9392 64.9223C33.9392 64.9223 39.216 77.6412 39.0655 78.0928Z"
        fill="#6E0AD6"
      />
    </svg>
  </View>
)

PurplePlaneIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

PurplePlaneIcon.defaultProps = {
  width: 96,
  height: 96,
}

export default PurplePlaneIcon
